import { Route, Redirect, RouteProps } from 'react-router-dom';
import { AGENCY_REPORTS_READ } from '../Constants/RolesAndPermissions';
import {
  AGENCY_INITIATIVES_READ,
  Subscription,
  SubscriptionsSummary,
  User,
  checkPermissions,
  isPlanConnect,
  isRoleWatcher
} from 'ui-smartforce-settings';

export interface RouteMainDefaultProps extends RouteProps {
  subscription?: Subscription;
  subscriptionsSummary?: SubscriptionsSummary;
  url: string;
  user: User;
}

export const RouteMainDefault = ({
  subscription,
  subscriptionsSummary,
  url,
  user
}: RouteMainDefaultProps) => (
  <Route
    children={() => {
      if (
        subscription?.status === 'Canceled' ||
        subscription?.status === 'Unpaid'
      ) {
        return (
          <Redirect
            to={{
              pathname: `/subscription-${
                subscription.status === 'Canceled' ? 'canceled' : 'paused'
              }`
            }}
          />
        );
      }

      let redirectPath: string = 'onboarding';

      if (
        subscription?.status === 'Active' ||
        subscription?.status === 'Past Due'
      ) {
        if (
          !subscriptionsSummary?.appPlan.cc ||
          isPlanConnect(subscriptionsSummary.appPlan.cc)
        ) {
          redirectPath = 'business-card';
        } else if (isRoleWatcher(user.role.id)) {
          redirectPath = 'analytics';
        } else {
          const allowCommandInitiatives =
            subscriptionsSummary.hasInitiativesIntegration &&
            checkPermissions(AGENCY_INITIATIVES_READ, user.role.permissions);

          const allowAgencyReports = checkPermissions(
            AGENCY_REPORTS_READ,
            user.role.permissions
          );

          redirectPath = allowCommandInitiatives
            ? 'command/initiatives'
            : allowAgencyReports
              ? 'agency-reports'
              : 'report';
        }
      }

      return <Redirect to={{ pathname: `${url}/${redirectPath}` }} />;
    }}
  ></Route>
);
